import request from '@/common/request'
export default {
  reportSelect:(url) => {
    return request({
      url: url,
      method: 'get'
    })
  },
  resourceSelect:(dynaSeg) => {
    return request({
      url: `/resource/list/${dynaSeg.resKey}`,
      method: 'get'
    })
  },
  orgTreeSelect:() =>{
    return request({
      url: '/org/0',
      method: 'get'
    })
  },
  supplierSelect:()=>{
    return request({
      url: '/supplier/listAll',
      method: 'get'
    })
  },
  deviceTypeSelect:()=>{
    return request({
      url: '/deviceType/listAll',
      method: 'get'
    })
  },
  articleTypeSelect:()=>{
    return request({
      url: '/articleType/selectArticleTypeList',
      method: 'get'
    })
  },
  terminalInfoSelect:()=>{
    return request({
      url: '/terminalInfo/selectTerminalList',
      method: 'get'
    })
  },
  terminalInfosByOrgId:(params)=>{
    return request({
      url: '/terminalInfo/terminalInfosByOrgId',
      method: 'get',
      params
    })
  },
  terminalInfoSelectByTerminalId:(params)=>{
    return request({
      url: '/terminalInfo/selectTerminalList',
      method: 'get',
      params
    })
  },
  deviceModelSelect:()=>{
    return request({
      url: '/deviceModel/listAll',
      method: 'get'
    })
  },
  areaDivisionCdsSelect:()=>{
    return request({
      url: '/administrative/listAllAsTree',
      method: 'get'
    })
  },
  divisionSelect:(dynaSeg) => {
    return request({
      url: `/administrative/getDivision/${dynaSeg.level}`,
      method: 'get'
    })
  },
  listAllAsTreeLessThan:(dynaSeg) => {
    return request({
      url: `/administrative/listAllAsTreeLessThan/${dynaSeg.level}`,
      method: 'get'
    })
  },
  getAllAlarmPolicySelect:()=>{
    return request({
      url: '/alarmPolicy/getAllAlarmPolicy',
      method: 'get'
    })
  },
}


// WEBPACK FOOTER //
// ./src/api/modules/select.js